module.exports = __webpack_public_path__ + "apple-e5dc42ea.png";